export default __webpack_public_path__ + "static/media/remove.c9fe757f.png";